/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Reorder_Failed1Inputs */

const vi_guidevideo_reorder_failed1 = /** @type {(inputs: Guidevideo_Reorder_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lưu được thứ tự video. Danh sách đã được tải lại, hãy kéo lại.`)
};

/**

* @param {Guidevideo_Reorder_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_reorder_failed1 = /** @type {((inputs?: Guidevideo_Reorder_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Reorder_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_reorder_failed1(inputs)
});
export { guidevideo_reorder_failed1 as "guideVideo_reorder_failed" }